import './App.css';
import {ConfigProvider} from 'antd';
import {Route, Routes} from 'react-router-dom';

import JsonData from './data/data.json';
import {AboutUs} from './screenComponent/AboutUs';
import {CareerScreen} from './screenComponent/CareerScreen';
import {Channel_partners} from './screenComponent/Channel_partners';
import {ContactUs} from './screenComponent/ContactUs';
import {GalleryScreen} from './screenComponent/GalleryScreen';
import {HomeScreen} from './screenComponent/HomeScreen';
import {LayoutComponent} from './screenComponent/LayoutComponent';
import {ScrollToTop} from './screenComponent/ScrollToTop';
import {Services} from './screenComponent/Services';

function App() {
  return (
    <ConfigProvider
      theme={{
        token: {
          colorPrimary: '#502f27',
        },
      }}
    >
      <div>
        <ScrollToTop />
        <Routes>       
          <Route path={'/'} element={<LayoutComponent />}>
            <Route index element={<HomeScreen />} />
            <Route path={'/about'} element={<AboutUs data={JsonData.AboutUs} />} />
            <Route path={'/services'} element={<Services data={JsonData.ServicesSection} />} />
            <Route path={'/gallery'} element={<GalleryScreen data={JsonData} />} />
            <Route path={'/contact-us'} element={<ContactUs data={JsonData.ContactUs} />} />
            <Route path={'/CareerScreen'} element={<CareerScreen data={JsonData.channel_partners1} />} />
            <Route path={'/channel'} element={<Channel_partners data={JsonData.channel_partners1} />} />
          </Route>    
        </Routes>
      </div>
    </ConfigProvider>
  );
}

export default App;
